module.exports = __webpack_public_path__ + "img/part-3-title.88b5395e.png";